import type { ControlAnchorOptions } from "./controlAnchorPoint";

/** Policy for navigator lookup. These are code defaults, not persisted project settings. */
export type NavigatorAnchorOptions = Readonly<
  Required<ControlAnchorOptions> & {
    /** null searches through the top-level collection; a number limits parent steps (0=device only). */
    maxParentDepth: number | null;
  }
>;

/** Central tuning point; the hook also accepts an explicit policy per navigator instance. */
export const DEFAULT_NAVIGATOR_ANCHOR_OPTIONS: NavigatorAnchorOptions = Object.freeze({
  maxParentDepth: null,
  scrollBehavior: "pin",
  edgeInset: 0,
});
